import axiosInstance from "../../../Utils/axiosInstance";


export interface TasAuditReportRow {
    "Trade Date": string;
    Symbol: string;
    Price: string;
    MTM: string;
    "API Price": string;
    "Expected Price": string;
    "Trade ID": string;
    "Leg ID": string;
    [key: string]: string;
}

export interface TasAuditReportResponse {
    status: boolean;
    summary: string[];
    count: number;
    columns: string[];
    data: TasAuditReportRow[];
}

export const getTasAuditReport = async (): Promise<TasAuditReportResponse> => {
    const response = await axiosInstance.get<TasAuditReportResponse>(
        "/paper-app/tas-audit-report/"
    );
    return response.data;
};